import React from "react";
import TopNavigation from "components/ui/TopNavigation";
import Icon from "components/AppIcon";
import ClassesManager from "../gym-owner-portal/components/ClassesManager";

export default function GymOwnerClasses() {
  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <TopNavigation />
      <main>
        <div className="bg-[var(--color-card)] border-b border-[var(--color-border)] px-4 md:px-6 py-4">
          <div className="max-w-screen-2xl mx-auto">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-md bg-[var(--color-primary)]/15 flex items-center justify-center">
                <Icon name="CalendarDays" size={15} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-lg font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Classes</h1>
                <p className="text-sm text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Schedule and manage fitness classes</p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-6">
          <ClassesManager />
        </div>
      </main>
    </div>
  );
}
